import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import style from './floatingbutton.module.css';
import DonateModal from "../donation/donatemodal"

const FLoatingbutton = () => {
  
  const navigate = useNavigate(); 
    const [showModal, setShowModal] = useState(false);
  const handleClick = () => {
    setShowModal(true)
    // navigate('/donate-to-us'); 
  };

  return (
    <>
        <div className={style.floatbutton}>
          <button onClick={handleClick}>D<br />O<br />N<br />A<br />T<br />E</button>
        </div>
        {showModal && (
  <DonateModal show={showModal} onHide={() => setShowModal(false)} />
)}

    </>
  );
};

export default FLoatingbutton;
